import $ from 'jquery';

import Section from "../Section";
import CartTerms from '../global/CartTerms';
import QuantityControls from '../global/QuantityControls';

export default class Cart extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.cartTerms = new CartTerms(theme, element);
    $('[name="checkout"], [name="goto_pp"], [name="goto_gc"]').on('click', this.cartTerms.checkTerms);

    this.quantityControls = new QuantityControls(this.theme, this.element, true);
  }
}
